"use strict";

import { auth } from "./auth.reducer";
import { campaign } from "./campaign.reducer";
import { user } from "./user.reducer";
import { shop } from "./shop.reducer";
import { successMessageReducer, errorMessageReducer } from "./message.reducer";
import { loadingSpinnerReducer } from "./loading.spinner.reducer";
import { knowledge } from "./knowledge.reducer";
import { home } from "./home.reducer";
import { common } from "./common.reducer";

export default {
    auth,
    campaign,
    user,
    loading: loadingSpinnerReducer,
    successMessage: successMessageReducer,
    errorMessage: errorMessageReducer,
    shop,
    knowledge,
    home,
    common,
};
